import { entityNameSorter, getProp } from '@lib/generic.utils'
import { agPriceCol, agStartDateCol, checkboxCol } from '@/ag-grid/ag-columns'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        columnDefs: [
          checkboxCol(),

          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name'
          },

          {
            headerName: 'Publisher',
            field: 'publisher',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name', ''),
            tooltipValueGetter: params => getProp(params.value, 'name', '')
          },

          agStartDateCol({ headerName: 'Period' }),

          {
            headerName: 'PO number',
            field: 'member_purchase_order_reference',
            tooltipField: 'member_purchase_order_reference'
          },

          agPriceCol('Price', 'price')
        ],
        domLayout: 'autoHeight'
      }
    }
  }
}
